var _style, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSimCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 422 512",
    style: {
      enableBackground: "new 0 0 422 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF6C37;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M390,448V173.2c0-12.7-5-25-14.1-33.9L266.7,30.1c-9-9-21.2-14.1-34-14.1H86c-26.5,0-48,21.5-48,48l0,0v384 c0,26.5,21.5,48,48,48l0,0h256C368.5,496,390,474.5,390,448L390,448L390,448z M70,448V64c0-8.8,7.2-16,16-16h146.7 c4.2,0,8.3,1.7,11.3,4.7l109.2,109.2c3,3,4.7,7.1,4.7,11.3V448c0,8.8-7.2,16-16,16H86C77.2,464,70,456.8,70,448z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M278,240H150c-17.7,0-32,14.3-32,32v128c0,17.7,14.3,32,32,32h128c17.7,0,32-14.3,32-32V272 C310,254.3,295.7,240,278,240z M278,320h-48v-48h48V320z M150,272h48v128h-48V272z M230,400v-48h48v48H230z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimCard);
export default __webpack_public_path__ + "static/media/sim-card.3f74823942b4fd7641cc5bc578d6dcda.svg";
export { ForwardRef as ReactComponent };